// TODO: this file should only exists in the ui package - since we use lit v3 in ui and lit v2 in app, we currently have a duplicate and this should be migrated once we have universal version
import { CSSResult, LitElement } from "lit";
import { property } from "lit/decorators.js";

// @ts-expect-error reason: raw-loader would not have any inferrable type
// eslint-disable-next-line import/no-unresolved
import unoStyles from "!!raw-loader!../styles/uno.css";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Constructor<T> = new (...args: any[]) => T;
export declare class StyledElementInterface {
    styles?: CSSResult;
}

export const StyledElementMixin = <T extends Constructor<LitElement>>(superClass: T) => {
    const utilitySheet = new CSSStyleSheet();
    utilitySheet.replaceSync(unoStyles);

    class StyledElement extends superClass {
        override connectedCallback() {
            super.connectedCallback();
            this.processStyles();
        }

        /** @internal */
        @property({ attribute: false })
        styles?: CSSResult;

        /** @internal */
        private processStyles() {
            if (this.renderRoot instanceof ShadowRoot) {
                const styleSheet = new CSSStyleSheet();

                if (this.styles) {
                    styleSheet.replaceSync(this.styles.toString());
                }
                this.renderRoot.adoptedStyleSheets = [styleSheet, utilitySheet];
            } else {
                const style = document.createElement("style");
                style.textContent = this.styles?.toString() || "";
                this.renderRoot.appendChild(style);
            }
        }
    }
    return StyledElement as Constructor<StyledElementInterface> & T;
};
